import React from 'react'
import { FiCopy } from 'react-icons/fi'
import { ModalDuasOpcoes } from '../../../../../components/Modais'
import { mostrarToast } from '../../../../../components/Toasts'

const copiarCodigo = (codigo) => {
    if (!codigo) return
    if (navigator?.clipboard?.writeText)
        navigator.clipboard.writeText(codigo).then(
            () => mostrarToast('sucesso', 'Código copiado!'),
            () => mostrarToast('erro', 'Não foi possível copiar o código.')
        )
    else {
        const input = document.createElement('input')
        input.value = codigo
        document.body.appendChild(input)
        input.select()
        try { document.execCommand('copy'); mostrarToast('sucesso', 'Código copiado!') }
        catch { mostrarToast('erro', 'Não foi possível copiar o código.') }
        document.body.removeChild(input)
    }
}

const ModalLoteGerado = ({ showModal, setShowModal, loteCriado, onFechar }) => (
    <ModalDuasOpcoes
        titulo={'Lote Gerado'}
        showModal={showModal}
        setShowModal={setShowModal}
        fecharModal={true}
        esconderOpcao2={true}
        textoOpcao1={'Fechar'}
        classeOpcao1={'btn-sm btn-primary-modal primary'}
        funcaoOpcao1={onFechar}
        mensagem={
            <div style={{ lineHeight: '1.8' }}>
                <div><b>Estabelecimento: </b>{loteCriado?.estabelecimento || '-'}</div>
                <div><b>Quantidade de Lançamentos: </b>{loteCriado?.quantidade ?? 0}</div>
                <div className='d-flex align-items-center'>
                    <b className='mr-2'>Código:&nbsp;</b>
                    <span style={{ fontFamily: 'monospace', fontSize: '1rem', fontWeight: 'bold', letterSpacing: '0.1rem' }}>
                        {loteCriado?.codigo || '-'}
                    </span>
                    <button
                        type='button'
                        className='btn btn-sm btn-outline-secondary ml-2'
                        onClick={() => copiarCodigo(loteCriado?.codigo)}
                        title='Copiar código'
                        style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 6px' }}>
                        <FiCopy />
                    </button>
                </div>
            </div>
        }
    />
)

export default ModalLoteGerado
